module.exports = __webpack_public_path__ + "static/media/in-company-courses.4d60b237.svg";